function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #626a84;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Menu:_Sent_Homeworks",
  "data-name": "Menu: Sent Homeworks",
  transform: "translate(-34.788 -270.879)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_664",
  "data-name": "Path 664",
  className: "cls-1",
  d: "M38.089,2.724a.794.794,0,0,0-.841-.24L8.039,12.26a.768.768,0,0,0-.48.985.785.785,0,0,0,.264.36l7.471,5.885v5.525a.759.759,0,0,0,.769.769.734.734,0,0,0,.48-.168l3.291-2.57,4.684,3.675A.765.765,0,0,0,25.6,26.6c.024-.024.048-.072.072-.1L38.185,3.613A.889.889,0,0,0,38.089,2.724Z",
  transform: "translate(32.737 269.553)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_365",
  "data-name": "Line 365",
  className: "cls-2",
  x1: 22.82,
  y2: 16.767,
  transform: "translate(48.007 272.277)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_366",
  "data-name": "Line 366",
  className: "cls-2",
  x2: 4.54,
  y2: 3.555,
  transform: "translate(48.007 289.044)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_665",
  "data-name": "Path 665",
  className: "cls-1",
  d: "M0,10.113c.144-.6.985-3.7,3.747-4.876.264-.12,3-1.249,4.3.12A2.352,2.352,0,0,1,8.455,7.9a2.726,2.726,0,0,1-3.219.985c-1.754-.6-2.09-3.195-2.018-4.54A6.331,6.331,0,0,1,5.525,0",
  transform: "translate(38.447 290.812) rotate(14)"
}));

var SvgSideSentHomework = function SvgSideSentHomework(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37.437 33.073",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSideSentHomework, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/side-sent-homework.3e0a44b5.svg";
export { ForwardRef as ReactComponent };